import React, {useEffect, useRef, useState} from 'react';
import {Image, ImageStyle, Text, View} from 'react-native';
import {getImageAspectRatio} from "../../../../../Common/Utils/image.utils";
import {LanguageManager, Managers, TranslationManager} from "@levelapp/softfabric";
import App from "../../../../../App";
import {styles} from "./InvestFlowHeaderViewStyle";

interface InvestFlowHeaderViewProps {
    titleTranslationKey: string;
    titleTranslationData?: any;
}

const investImgUrl = "https://beebondsstorage.blob.core.windows.net/files/web/identification.svg";

export const InvestFlowHeaderView = ({titleTranslationKey, titleTranslationData=""}: InvestFlowHeaderViewProps) => {
    const [investRatio, setInvestRatio] = useState<number>(0);
    const investImgHeight = useRef(100);

    const translationManager: TranslationManager = App.current.resolve<TranslationManager>(Managers.TRANSLATION_MANAGER);
    const languageManager: LanguageManager = App.current.resolve<LanguageManager>(Managers.LANGUAGE_MANAGER);

    const calculateInvestImgHeight = () => {
        return investImgHeight.current;
    }

    const calculateInvestImgWidth = () => {
        return calculateInvestImgHeight() * investRatio;
    }

    const imageStyle: ImageStyle = {
        height: investImgHeight.current,
        width: calculateInvestImgWidth(),
        resizeMode: 'contain',
    }

    useEffect(() => {
        (async () => {
            const ratio = await getImageAspectRatio(investImgUrl);
            setInvestRatio(ratio);
        })();
    }, []);

    return (
        <View style={[styles.page]}>
            <Image source={{uri: investImgUrl}} style={[styles.investImage, imageStyle]}/>
            <Text style={[styles.title]}>{translationManager.translate(titleTranslationKey, languageManager.language).replace("${data}", titleTranslationData)}</Text>
        </View>
    );
}

export default InvestFlowHeaderView;